/**
 * Listbox role.
 * @public
 */
export var ListboxRole;
(function (ListboxRole) {
    ListboxRole["listbox"] = "listbox";
})(ListboxRole || (ListboxRole = {}));
